var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"row mb-4 justify-content-center"},[_c('div',{staticClass:"col-auto"},[_c(_vm.injections.components.Title,_vm._b({tag:"component"},'component',_vm.data.attrs,false),[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }